import catalogos from './catalogos/catalogos'
import sistema from "./Sistema/sistemaSIVAC";

const sivac = {
  catalogos: catalogos,
  sistema: sistema  
}
export default sivac


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/SIVACapi.js
// module id = null
// module chunks = 